import BaseTokenProvider from './BaseTokenProvider'
import FormatUtils from '@/utils/FormatUtils'

var DataTypeTokenProvider = function() {
    BaseTokenProvider.call(this);
};
DataTypeTokenProvider.prototype = new BaseTokenProvider();

/**
 * @inheritDoc
 */
DataTypeTokenProvider.prototype.getSupportedTokens = function () {
    return ["distance", "weight", "boolean", "elevation", "duration", "date", "datetime", "date_time", "time", "speed", "length", "shortdistance", "short_distance", "lenght"];
};

DataTypeTokenProvider.prototype.resolveTextToken = function(mapObject, token, field, defaultValue) {
    var value = defaultValue;
    if (token === "distance") {
        var meters = parseFloat(value);
        return FormatUtils.formatDistance(meters);
    } else if (token === "weight") {
        var grams = parseFloat(value);
        return FormatUtils.formatWeight(grams);
    } else if (token === "boolean") { 
        return FormatUtils.formatBoolean(parseInt(value)==1||value=="true");
    } else if (token === "date") {
        var date = new Date(value);
        return FormatUtils.formatDate(date);
    } else if (token === "datetime" || token === "date_time") {
        var dateTime = new Date(value);
        return FormatUtils.formatDateTime(dateTime);
    } else if (token === "time") {
        var time = new Date(value);
        return FormatUtils.formatTime(time);
    } else if (token === "duration") {
        var minutes = parseFloat(value);
        return FormatUtils.formatDuration(minutes);
    } else if (token === "elevation") {
        var elevation = parseFloat(value);
        return FormatUtils.formatElevation(elevation);
    } else if (token === "speed") {
        var metersPerHour = parseFloat(value);
        return FormatUtils.formatSpeed(metersPerHour);
    } else if (token === "length" || token === "lenght" || token === "shortdistance" || token.equals === "short_distance") {
        var centimeters = parseFloat(value);
        return FormatUtils.formatShortDistance(centimeters);
    }
    return value;

}

export default DataTypeTokenProvider;
